// src/firebase-config.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth"; // 1. Import getAuth
import { getFunctions } from "firebase/functions"; // 1. Import

// TODO: Dán object firebaseConfig của bạn vào đây
const firebaseConfig = {
  apiKey: "AIzaSyCHeIq1jhYiMHyjF4O-YLGUiW8dr1ADp1M",
  authDomain: "toa-boki-d9298.firebaseapp.com",
  projectId: "toa-boki-d9298",
  storageBucket: "toa-boki-d9298.firebasestorage.app",
  messagingSenderId: "437447491629",
  appId: "1:437447491629:web:125b86b164932355c9b8a4"
};

// Khởi tạo Firebase
const app = initializeApp(firebaseConfig);

// Export các service của Firebase để sử dụng trong ứng dụng
export const db = getFirestore(app); // Firestore Database
export const storage = getStorage(app); // Firebase Storage
export const auth = getAuth(app); // 2. Khởi tạo và export auth
export const functions = getFunctions(app); // 2. Khởi tạo và export